import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class DonorsByTimeFrameRoute extends Route {
  @service navbarSettings;

  beforeModel() {
    this.navbarSettings.title = 'Donors by Time Frame';
  }
}
